/** Genres on which not to show the SR */
export const genresExclusion = new Set(['rma', 'fml', 'spt', 'cmy']);

export const audienceTags = new Set([
	'abandoned',
	'action',
	'ai',
	'alien_encounter',
	'androids_and_robots',
	'apocalypse',
	'atmospheric',
	'benign_alien',
	'body_horror',
	'cat_and_mouse',
	'chaos_and_mayhem',
	'characters_in_danger',
	'claustrophobic',
	'confined',
	'confinement_indoors',
	'contamination',
	'corporate_world',
	'creature',
	'crew',
	'cyberspace',
	'dangerous_animal',
	'dark_humor',
	'deadly',
	'deadly_creature',
	'deathtrap',
	'distant_planet',
	'disturbing',
	'dystopia',
	'evil_alien',
	'future_dystopia',
	'futuristic',
	'gloomy',
	'horror',
	'hunt_down',
	'infected',
	'infection',
	'isolation',
	'killing_off_one_by_one',
	'manhunt',
	'mercenary',
	'mind_bending',
	'mission',
	'mission_gone_awry',
	'monster',
	'mysterious_character',
	'mysterious_place',
	'mysterious_planet',
	'nightmare',
	'parallel_world',
	'paranoia',
	'parasite',
	'peril',
	'powerful_corporation',
	'psychological',
	'race_against_time',
	'scary',
	'sci_fi',
	'space_and_aliens',
	'space_station',
	'space_travel',
	'space_wars',
	'spacecraft',
	'spacewalk',
	'special_forces',
	'survival',
	'survivor',
	'suspenseful',
	'teamwork',
	'tense',
	'thriller',
	'time_travel',
	'trapped',
	'twists_and_turns',
	'virtual_reality',
	'who_to_trust',
]);
